import { Fragment, useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { Contract } from "../../../../models/Entities/Contracts/Contract"
import { ContractToClone } from "../../../../models/Entities/Contracts/ContractToClone"
import { CompoundButton, DefaultButton, FontIcon, Label, Separator, Spinner } from "@fluentui/react"
import { ContractAddendum } from "../../../../models/Entities/Contracts/ContractAddendum"
import { useNavigate } from "react-router-dom"

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// component functions
import * as ComponentFunctions from './Addendums.Functions'

// styles
import './Addendums.Styles.css'

// components
import { ErrorMessageComponent } from "../../../Error/ErrorMessageComponent"
import { NewContractAddendum } from "../../../../models/Entities/Contracts/NewContractAddendum"
import { AddendumItemComponent } from "./Addendum.Item.Component"
import { ArrowCircleRight28Regular, Add28Regular } from "@fluentui/react-icons"
import AddendumFormComponent from "../Addendum.Form/Addendum.Form.Component";
import NegotiationAddendumFormComponent from "../NegotiationAddendum.Form/NegotiationAddendum.Form.Component";
import ConfirmDialog from "../../../../commons/component/ConfirmDialog/ConfirmDialog";
import { Button, Divider } from "@fluentui/react-components"

const AddendumsComponent = (props: ComponentFunctions.Props) => {

    const [SelectedAddendum, setSelectedAddendum] = useState<ContractAddendum | undefined>();
    const rowRef = useRef<HTMLDivElement | null>(null);

    // add or update form controll
    const [isAddendumFormOpen, setIsAddendumFormOpen] = useState(false);
    const [isNegotiationAddendumFormOpen, setIsNegotiationAddendumFormOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingDeleteAddendum, setPendingDeleteAddendum] = useState<ContractAddendum | undefined>();
    const [deletingAddendumId, setDeletingAddendumId] = useState<number | undefined>();

    //useTranslation()
    const [t] = useTranslation();

    // Effects
    useEffect(() => {
        props.GetContractById(props.ContractId);
    }, [props.ContractId, props.GetContractById]);

    useEffect(() => {
        props.GetContractAddendumsByContractId(props.ContractId);
    }, [props.Contract !== undefined, (props.Contract?.addendums === undefined || props.Contract?.addendums.length === 0)]);

    useEffect(() => {
        if (SelectedAddendum || !(props.Addendums?.length)) {
            return;
        }

        const todayAddendum = props.Addendums.find(ComponentFunctions.isCurrentAddendum);
        const defaultAddendum = todayAddendum ?? props.Addendums[0];

        if (defaultAddendum) {
            setSelectedAddendum(defaultAddendum);
            props.OnAddendumSelected(defaultAddendum);
        }
    }, [SelectedAddendum, props.Addendums, props.OnAddendumSelected]);

    // Scroll active addendum into view when selection changes
    useEffect(() => {
        if (!SelectedAddendum) return;
        const el = document.getElementById(`addendum-${SelectedAddendum.id}`);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
    }, [SelectedAddendum]);

    useEffect(() => {
        if (deletingAddendumId === undefined) return;
        const stillExists = (props.Addendums || []).some(a => a.id === deletingAddendumId);
        if (!stillExists) {
            setDeletingAddendumId(undefined);
        }
    }, [props.Addendums, deletingAddendumId]);


    // events ---------------------------------------------------------------------

    // Handle Create Contract Addendum
    const CreateContractAddendumHandler = () => {

        // const NewAddendum: NewContractAddendum = {
        //     contractAddendumName: props.Contract?.contractNumber + ' - Adenda ' + ((props.Contract?.addendums || []).length + 1),
        //     contractAddendumDescription: '',
        //     contractId: props.ContractId
        // };

        var AddendumToCloneId = (props.Addendums?.length && props.Addendums.length > 0) ? props.Addendums[props.Addendums?.length - 1]?.id : 0;

        props.CloneAddendum(props.ContractId, AddendumToCloneId);
    }

    const EditContractAddendum = () => {
        setIsAddendumFormOpen(true);
    }

    const EditAddendumHandler = (addendum: ContractAddendum) => {
        setSelectedAddendum(addendum);
        props.OnAddendumSelected(addendum);
        setIsAddendumFormOpen(true);
    }

    const DeleteAddendumHandler = (addendum: ContractAddendum) => {
        setPendingDeleteAddendum(addendum);
        setConfirmOpen(true);
    }

    // Handle Select Addendum
    const SelectAddendumHandler = (addendum: ContractAddendum) => {
        setSelectedAddendum(addendum);
        props.OnAddendumSelected(addendum);
    }

    const onCloseAddendumForm = () => {
        setIsAddendumFormOpen(false);
    }

    const OpenNegotiationAddendumFormHandler = () => {
        setIsNegotiationAddendumFormOpen(true);
    }

    const onCloseNegotiationAddendumForm = () => {
        setIsNegotiationAddendumFormOpen(false);
    }


    // content

    const NoAdendums = (
        <div>

        </div>
    );

    const NoNegotiationAddendums = (
        <Button
            size="large"
            shape="circular"
            icon={<Add28Regular />}
            onClick={OpenNegotiationAddendumFormHandler}
            title="Nueva negociación"
        />
    );

    const GetAddendumCSSClass = (addendum: ContractAddendum, contractId: number): string => {
        var CssClass = '';
        CssClass = + addendum?.contractId === contractId ? 'Active' : '';

        const isCurrent: boolean = ComponentFunctions.isCurrentAddendum(addendum);
        const isExpired: boolean = ComponentFunctions.isExpiredAddendum(addendum);
        const isPending: boolean = !isCurrent && !isExpired;


        if (isCurrent) {
            CssClass += ' CurrentAddendum';
        }

        if (isExpired) {
            CssClass += ' ExpiredAddendum';
        }

        if (isPending) {
            CssClass += ' PendingAddendum';
        }

        return CssClass;
    }

    const Actions = (
        <div className="AddendumActions">
            <DefaultButton
                text="Agregar Adenda"
                iconProps={{ iconName: props.isCreatingAddendum ? 'Sync' : 'Copy', className: props.Contract?.isCloning ? 'withRotation' : '' }}
                onClick={CreateContractAddendumHandler}
                className='optionButton'
            />
        </div>
    )

    const Loading = (props.isLoading || props.isGettingAddendums) && (
        <div>
            <Spinner
                ariaLive="assertive"
                labelPosition="top"
            />
        </div>
    );

    const Forms = (
        <>
            {SelectedAddendum && <AddendumFormComponent
                AddendumId={SelectedAddendum?.id}
                ContractId={props.ContractId}
                isOpen={isAddendumFormOpen}
                onClose={onCloseAddendumForm}
            />}
            <NegotiationAddendumFormComponent
                ContractId={props.ContractId}
                isOpen={isNegotiationAddendumFormOpen}
                onClose={onCloseNegotiationAddendumForm}
            />
        </>
    )

    return (
        <>
            {props.Contract?.error && <ErrorMessageComponent Error={props.Contract?.error} />}
            <div className="AddendumsContent">
                <div className="AddendumsRow" ref={rowRef}>
                    {Loading}
                    {process.env.REACT_APP_PREVIEW_FEATURES === 'true' && <>
                        <Label>Negociación</Label>
                        {props.NegociationAddendums?.length ? props.NegociationAddendums.map((addendum: ContractAddendum, index: number) => (
                            <Fragment key={addendum.id}>
                                <AddendumItemComponent
                                    Addendum={addendum}
                                    SelectedAddendum={SelectedAddendum}
                                    OnSelect={SelectAddendumHandler}
                                    OnEdit={EditAddendumHandler}
                                    OnDelete={DeleteAddendumHandler}
                                    DeletingId={deletingAddendumId}
                                />
                            </Fragment>
                        )) : NoNegotiationAddendums}
                        <Divider vertical style={{ margin: '0 10px', height: '7em' }} />
                    </>}
                    <Label>Ejecución</Label>
                    {props.Addendums?.length ? props.Addendums.map((addendum: ContractAddendum, index: number) => (
                        <Fragment key={addendum.id}>
                            <AddendumItemComponent
                                Addendum={addendum}
                                SelectedAddendum={SelectedAddendum}
                                OnSelect={SelectAddendumHandler}
                                OnEdit={EditAddendumHandler}
                                OnDelete={DeleteAddendumHandler}
                                DeletingId={deletingAddendumId}
                            />
                            {(index + 1) < (props.Addendums?.length ?? 0) && <ArrowCircleRight28Regular />}
                        </Fragment>
                    )) : NoAdendums}
                    {/* Arrow then add button as icon-only */}
                    <ArrowCircleRight28Regular />
                    <DefaultButton
                        className={'AddendumAddButton'}
                        onClick={CreateContractAddendumHandler}
                        iconProps={{ iconName: 'Add' }}
                        title="Agregar adenda"
                    />
                </div>
                <ConfirmDialog
                    open={confirmOpen}
                    title={t('commons.confirmDialog.deleteTitle', 'Confirmar eliminación')}
                    message={t('contractAssociation.visitFormConceptPayableList.confirmDeleteItemLabel', 'Se va a borrar el elemento')}
                    highlight={pendingDeleteAddendum?.contractAddendumName}
                    confirmText={t('common.delete', 'Eliminar')}
                    cancelText={t('common.cancel', 'Cancelar')}
                    onCancel={() => { setConfirmOpen(false); setPendingDeleteAddendum(undefined); }}
                    onConfirm={() => {
                        if (pendingDeleteAddendum?.id) {
                            setDeletingAddendumId(pendingDeleteAddendum.id);
                            props.DeleteContractAddendum(props.ContractId, pendingDeleteAddendum.id);
                        }
                        setConfirmOpen(false);
                        setPendingDeleteAddendum(undefined);
                    }}
                />
                {Forms}
            </div>
        </>
    )
}

export default connect(ComponentFunctions.mapStateToProps, ComponentFunctions.mapDispatchToProps)(AddendumsComponent as any)